export default __webpack_public_path__ + "static/media/white_fault.d2c4e90d.svg";